import { registerPlugin } from '@capacitor/core';

const NativeAudioPlayer = registerPlugin('NativeAudioPlayer');

export default NativeAudioPlayer;
